<template>
  <div style="display: inline-block; position: relative;">
    <input
      type="text"
      :name="inputName"
      autocomplete="off"
      class="input-time form-control form-control-sm"
      :value="formatTime(value)"
      v-bind="$attrs"
      @blur="updateValue"
      @focus="showTimes = true"
    >
    <ul v-if="showTimes" class="time-options list-unstyled">
      <li v-for="time in timeIntervals" @click="chooseTime(time)">
        {{ time }}
      </li>
    </ul>
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    inheritAttrs: false,
    props: {
      value: {
        type: String
      },
      inputName: {
        type: String,
        default: 'time'
      }
    },
    data() {
      return {
        showTimes: false
      };
    },
    computed: {
      timeIntervals() {
        const start = moment().set({hour: 0, minute: 0, second: 0});
        const end = moment().set({hour: 23, minute: 59, second: 0});

        let t = [];
        for (let time = start; time.isSameOrBefore(end); time.add(30, 'minutes')) {
          t.push(time.format('LT'));
        }
        t.push(end.format('LT'));
        return t;
      }
    },
    methods: {
      formatTime(time) {
        if (!time) {return '';}
        return moment(time, ['LT', 'h:mm:ss']).format('LT');
      },
      updateValue(event) {
        this.$emit('input', this.formatTime(event.target.value));
        this.$emit('blur');

        setTimeout(() => {
          this.showTimes = false;
        }, 200);
      },
      chooseTime(time) {
        this.$emit('input', time);
        this.$emit('blur');
        this.showTimes = false;
      },
    },
  };
</script>

<style scoped>
  .time-options {
    position: absolute;
    left: 0px;
    overflow: auto;
    z-index: 10000;
    width: 100px;
    height: 150px;
    background: #ffffff;
    padding: 5px;
    border: 1px solid #dddddd;
    border-radius: 3px;
    box-shadow: rgba(0,0,0,0.1) 0px 0px 6px;
  }

  .time-options li {
    cursor: pointer;
  }
</style>
